module.exports = __webpack_public_path__ + "media/images/zj11-w1-421b154a9e3c94abba2229a9fe6b9470.png";